export default "__VITE_ASSET__vej6JGNC__"